const IconCircle = ({ bgColor = "#f3f4f6", size = 36, tooltip, children }) => (
  <div
    title={tooltip}
    style={{
      cursor: 'pointer',
      width: size,
      height: size,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: bgColor,
      flexShrink: 0,
    }}
  >
    {children}
  </div>
);

const INACTIVE_BG    = "#f3f4f6";
const INACTIVE_ICON  = "#9ca3af";

export const DeliveryIcon = ({ uiState }) => {
  const { hasActions, size = 28 } = uiState || {};
  const bgColor   = hasActions ? "#dcfce7" : INACTIVE_BG;   // green-100
  const iconColor = hasActions ? "#4ade80" : INACTIVE_ICON; // green-400
  const tooltip = hasActions ? "Problemas de Abastecimento" : "Sem problemas de Abastecimento";

  return (
    <IconCircle bgColor={bgColor} size={size} tooltip={tooltip}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none"
        stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="1"/>
        <path d="M16 8h4l3 5v4h-7V8z"/>
        <circle cx="5.5" cy="18.5" r="2.5"/>
        <circle cx="18.5" cy="18.5" r="2.5"/>
      </svg>
    </IconCircle>
  );
};

export const CartIcon = ({ uiState }) => {
  const { hasActions, size = 28 } = uiState || {};
  const bgColor   = hasActions ? "#fff7ed" : INACTIVE_BG;   // orange-50
  const iconColor = hasActions ? "#f97316" : INACTIVE_ICON; // orange-400
  const tooltip = hasActions ? "Problemas de Compra" : "Sem problemas de Compra";

  return (
    <IconCircle bgColor={bgColor} size={size} tooltip={tooltip}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none"
        stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
    </IconCircle>
  );
};

export const GridIcon = ({ uiState }) => {
  const { hasActions, size = 28 } = uiState || {};
  const bgColor   = hasActions ? "#fee2e2" : INACTIVE_BG;   // red-100
  const iconColor = hasActions ? "#dc2626" : INACTIVE_ICON; // red-600
  const tooltip = hasActions ? "Problemas de Sortimento" : "Sem problemas de Sortimento";

  return (
    <IconCircle bgColor={bgColor} size={size} tooltip={tooltip}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none"
        stroke={iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
      </svg>
    </IconCircle>
  );
};